/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import type { IconProps } from './types/index';

function IcCalendarRegular({ className, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 24 24"
      className={`kc-console-icon ${className ? className : ''}`}
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M7 1.6a.9.9 0 0 1 .9.9v1.1h8.2V2.5a.9.9 0 0 1 1.8 0v1.1H20a2.9 2.9 0 0 1 2.9 2.9v13a2.9 2.9 0 0 1-2.9 2.9H4a2.9 2.9 0 0 1-2.9-2.9v-13A2.9 2.9 0 0 1 4 3.6h2.1V2.5a.9.9 0 0 1 .9-.9m9.1 3.8v1.1a.9.9 0 0 0 1.8 0V5.4H20a1.1 1.1 0 0 1 1.1 1.1v3.1H2.9V6.5A1.1 1.1 0 0 1 4 5.4h2.1v1.1a.9.9 0 0 0 1.8 0V5.4zm-13.2 6h18.2v8.1a1.1 1.1 0 0 1-1.1 1.1H4a1.1 1.1 0 0 1-1.1-1.1z"
        clipRule="evenodd"
      />
    </svg>
  );
}
export default IcCalendarRegular;
